import { lng } from '@ads/front-core/locales'

interface IRecommendation {
  author: string
  opinion: string
}

export const recommendations: IRecommendation[] = [
  {
    author: 'Tomasz Cudzich, torebki-skorzane.pl',
    opinion: lng('landing:recommendation-1'),
  },
  {
    author: 'Jaroslaw Cybulski, janda.pl',
    opinion: lng('landing:recommendation-2'),
  },
]
